import React, { useEffect, useState } from 'react';
import SocialMedia from '../SocialMedia';
import LogoPlaceholder from '../LogoPlaceHolder';
import { Promoter } from '../../types/promoter';
import { getPaymentProviders } from '../../services/paymentProvidersService';
import { PAYMENT_PROVIDERS } from '../../constants/paymentProviders';

interface FooterProps {
    promoter: Promoter;
    loading: boolean;
}

const Footer = React.forwardRef<HTMLElement, FooterProps>((props, ref) => {
    const { promoter, loading } = props;

    const [availablePaymentProviders, setAvailablePaymentProviders] = useState<any[]>([]);
    useEffect(() => {
        getPaymentProviders().then(setAvailablePaymentProviders).catch(() => setAvailablePaymentProviders([]));
    }, []);
    const isMercadoPagoAvailable = availablePaymentProviders.some(provider => provider.code === PAYMENT_PROVIDERS.MERCADO_PAGO);

    if (loading) return <p></p>;

    return (
        <footer className="footer" ref={ref}>
            <div className="footer__wrapper">
                <div className="footer__column-logo">
                    <ul>
                        <li>
                            {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname} className="logo" style={{ backgroundColor: 'white' }} /> : <LogoPlaceholder name={promoter.fullname} />}
                        </li>
                        <li>
                            <p>(c) {new Date().getFullYear()} powered by tripPromoter Inc.</p>
                        </li>
                    </ul>
                </div>
                <div className='border__footer'></div>
                <div className="footer__column-contact">
                    <ul>
                        <li>
                            <p style={{ color: 'white', opacity: 0.5, marginBottom: '10px' }}>Medios de pago</p>
                        </li>
                        <li>
                            <div style={{ display: 'flex', gap: '15px', marginBottom: '10px', flexWrap: 'wrap', justifyContent: 'center', maxWidth: '200px' }}>
                                <img src='https://img.trippromoter.com/files/pm/visa.png' alt='Visa' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/master.png' alt='Mastercard' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/amex.png' alt='American Express' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/diners.png' alt='Diners' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/cabal.png' alt='Cabal' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/deposit.svg' alt='Transferencia' title='Transferencia bancaria' style={{ height: '25px', width: '40px', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                <img src='https://img.trippromoter.com/files/pm/cash.svg' alt='Deposito' title='Depósito en efectivo' style={{ height: '25px', width: '40px', opacity: 1, backgroundColor: 'white', padding: '3px', borderRadius: '2px' }} />
                                {isMercadoPagoAvailable && (
                                    <span className="footer__payment-method" style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', backgroundColor: 'white', padding: '3px', borderRadius: '2px' }}>
                                        <img src='https://img.trippromoter.com/files/pm/mercadopago.png' alt='Mercado Pago' style={{ height: '25px', width: 'auto', opacity: 1, backgroundColor: 'white', borderRadius: '2px' }} />
                                        <span style={{ color: 'black', opacity: 1, fontSize: '12px', marginLeft: '5px', background: 'none', padding: 0 }}>Hasta 12 cuotas</span>
                                    </span>
                                )}
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="footer__column-terms">
                    <ul>
                        <li>
                            <a href="https://www.trippromoter.com/terms-and-conditions" rel="noreferrer" target="_blank">Términos y Condiciones</a>
                        </li>
                        <li>
                            <a href="https://www.trippromoter.com/privacy-policy" rel="noreferrer"
                                target="_blank">Políticas de Privacidad</a>
                        </li>
                        <li>
                            <span className="footer__leg-number">BTCOM LEG N°17779</span>
                        </li>
                    </ul>
                </div>
                <div className="footer__column-icons">
                    <p>Follow Us</p>
                    <SocialMedia />
                </div>
            </div>
        </footer>
    );
});

export default Footer;
